import { GQLIdEncoder } from '../../common/utils/GQLIdEncoder';
import { Report } from '../models/Report';
import { SlotMapper } from './SlotMapper';

export class ReportMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();
  readonly slotBreadcrumbMapper = new SlotMapper();

  mapGQLModel(data: any): Report {
    const slot = data.slot ? this.slotBreadcrumbMapper.mapGQLModel(data.slot) : null;
    return new Report(data.id, this.gqlIdEncoder.decode(data.id), data.name, data.traceType, slot);
  }
}
